import * as $ from "jquery";
import * as _ from "lodash";

import React, { Component } from "react";
import ReactDOM from "react-dom";
import ScrollMenu from "react-horizontal-scrolling-menu";
import { viewerOptions } from "../viewer";
import { UiUtils } from "../common/uiUtils";
import { ViewerUtils } from "../common/viewerUtils";

const MenuItem = ({ text, selected }) => {
    return <div className={`menu-item ${selected ? "active" : ""}`}>{text}</div>;
};

export const Menu = (list, selected) =>
    list.map((el, index) => {
        const { name } = el;
        return <MenuItem text={name} key={index + ""} selected={selected} />;
    });


const Arrow = ({ text, className }) => {
    return (
        <div className={className}>{text}</div>
    );
};


const ArrowLeft = Arrow({ text: "<", className: "arrow-prev" });
const ArrowRight = Arrow({ text: ">", className: "arrow-next" });

interface TourMenuProps {
    viewer: any;
}

interface TourMenuState {
    selected: string;
}

class TourMenu extends React.Component<TourMenuProps, TourMenuState> {
    private menuItems;
    private scrollMenu;
    constructor(props) {
        super(props);
        this.scrollMenu = React.createRef();
        this.menuItems = Menu(viewerOptions.tourData.pois, null);
        this.state = { selected: null };
    }

    componentDidMount(): void {
        const defaultName = viewerOptions.tourData.defaultPoiName;
        const pois = viewerOptions.tourData.pois;
        const defaultIndex = pois.findIndex(p => p.name === defaultName);
        if (defaultIndex >= 0) {
            this.onSelect(defaultIndex);
        }

        this.scrollMenu.current.resizeHandler();
    }

    onSelect = key => {
        const { idMap } = viewerOptions;
        this.setState({ selected: key });
        $("#tour-details").html(viewerOptions.tourData.pois[key].description);
        UiUtils.showUiElement("tour-details-pane");
        let elementIds = viewerOptions.tourData.pois[key].visibleElementIds;
        if (elementIds == null) {
            // Full tour
            ViewerUtils.turnAllNodesOn(this.props.viewer);
        } else {
            ViewerUtils.turnAllNodesOff(this.props.viewer);

            if (viewerOptions.tourData.idProperty != null) {
                // Need to use the external id mapping.
                elementIds = elementIds.map(id => viewerOptions.tourData.paramsToDbIds[id]);
            } else {
                elementIds = idMap.nodeIds(idMap.modelGuid(1), elementIds);
            }
            ViewerUtils.turnNodesOn(elementIds, this.props.viewer);
        }
    }

    render() {
        const { selected } = this.state;

        return (
            <ScrollMenu
                ref={this.scrollMenu}
                data={this.menuItems}
                arrowLeft={ArrowLeft}
                arrowRight={ArrowRight}
                hideSingleArrow={true}
                hideArrows={true}
                selected={selected}
                onSelect={this.onSelect}
                translate={0}
                alignCenter={true}
                alignOnResize={true}
                dragging={true}
                scrollToSelected={true}/>
        );
    }
}

const initMenu = (viewer) => {
    const menuDiv = document.getElementById("tour-menu");
    if (menuDiv != null) {
        ReactDOM.render(<TourMenu viewer={viewer}/>, menuDiv);
        UiUtils.showUiElement("tour-menu");
        const toolbar = $("#guiviewer3d-toolbar");
        toolbar.addClass("adsk-toolbar-vertical");
        toolbar.addClass("tour-toolbar");
    }
}

export { initMenu }